export const apiBaseUrl = 'https://api.eyepax.net';
export const imageBaseUrl = 'https://rec.eyepax.net/Attachments/';
export const  JIRA_TICKET_URL = 'https://eyepax.atlassian.net/browse/';

/* TABLE CONFIG */
export const DEFAULT_ROWS_PER_PAGE = 100;
